import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Box, Grid, Typography, Button } from '@mui/material'
import DealItem from '@components/DealItem'
import { getDealList } from '@hooks/contract'
import { useWallet } from '@utils/walletHelper'
import ClockLoader from '@components/Loaders/Clock'
import '../NotFound/NotFound.scss'
import Layout from "../Layout"

const MyStakeList = () => {
  const { connecting, connected, walletAddress } = useWallet()
  const [dealList, setDealList] = useState(null)
  const [loader, setLoader] = useState(false)

  useEffect(() => {
    let isMounted = true
    const fetchDataHandler = async () => {
      if (!connecting) {
        setLoader(true)
        try {
          const result = await getDealList(walletAddress, "my_stakes")
  
          if (isMounted) {
            setDealList(result)
          }
        } catch (error) {
          console.log(error)
        }
        setLoader(false)
      }
    }

    fetchDataHandler()

    return () => { isMounted = false }
  }, [walletAddress, connecting, setDealList, setLoader])

  // useEffect(() => {
  //   let _interval = setInterval(() => {
  //     fetchData()
  //   }, 10000)
    
  //   return () => {
  //     clearInterval(_interval)
  //   }
  // })

  const fetchData = async () => {
    const result = await getDealList(walletAddress, "my_stakes")
    if(result) {
      setDealList(result)
      return true
    } else {
      return false
    }
  }

  return (
    <Layout>
      {connected ? (
        <>
          <Box
            sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
          >
            <Typography
              variant="h2"
              className="font-40 font-bold"
              sx={{ mt: 3, mb: 5 }}
            >
              Deals I have stakes in as an investor
            </Typography>
          </Box>
          {dealList !== null && dealList.length > 0 ? (
            <Grid container spacing={2}>
              {
                dealList.slice(0).reverse().map((data, index) => {
                  return (
                    <Grid
                      key={index}
                      item
                      xs={12}
                      sm={6}
                      md={4}
                      lg={4}
                      xl={3}
                    >
                      <Link
                        to={`/deal/${data.id}`}
                        className="no_underline text-white"
                      >
                        <DealItem data={data} />
                      </Link>
                    </Grid>
                  )
                })
              }
            </Grid>
          )
            : !loader && (
              <Box
                sx={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", paddingTop: "15vh" }}
              >
                <Box>There is no data</Box>
              </Box>
            )
          }
        </>
      ) : (
        <Box className="page-404">
          <Typography variant="h1">
            404
          </Typography>
          <Typography variant="h6">
            Page Not Found
          </Typography>
          <Typography sx={{ pb: 2 }}>
            Please connect your wallet to view the contents of this page.
          </Typography>
          <Link to="/" className="no_underline text-white">
            <Button className="btn-info">
              Go to Home
            </Button>
          </Link>
        </Box>
      )
      }
      {loader && <ClockLoader />}
    </Layout>
  )
}

export default MyStakeList;